import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { Address } from '../models/user.model';
import { RequestService } from './request.service';

@Injectable()

export class AddressService {

    stato: string;
    provincia: string;
    localita: string;
    via: string;
    cap: string;
    civico: string;
    MaxMatch: number;
    MutexAddress: boolean;
    RegexNum = new RegExp(/^([0-9]+)$/m);

    citiesServiceSubscription: Subscription;
    streetServiceSubscription: Subscription;
    addressServiceSubscription: Subscription;
    // province => cities 
    italianCitiesOfProvince = new Map();
    italianStreets = new Map();

    constructor(protected _requestService: RequestService) {
        this.MutexAddress = true;
    }

    VerifyStreet(address: Address): Promise<any> {
        var { stato, localita, via } = address;
        if (this.streetServiceSubscription)
            this.streetServiceSubscription.unsubscribe();
        var key = stato + "-" + localita + "-" + via;
        if (this.italianStreets.has(key)) {
            return Promise.resolve(this.italianStreets.get(key));
        }

        return new Promise((resolve, reject) => {
            this.streetServiceSubscription = this._requestService.makeRequest('rest/internal/action/retrieveStreets',
                {
                    "countryCode": stato,
                    "town": localita,
                    "searchText": via
                },
                (data: Array<any>) => {
                    this.italianStreets.set(key, data);
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVERE", content: error.statusText })
                },
                null,
                false,
                null,
                3000,
                false,
                false
            )
        })
    }

    NormalizeAddress(address: Address): Promise<any> {
        var { stato, localita, via, civico ,provincia } = address;
        provincia = (provincia+"").replace('ITA-','');
        if (this.addressServiceSubscription)
            this.addressServiceSubscription.unsubscribe();
        return new Promise((resolve, reject) => {
            this.addressServiceSubscription = this._requestService.makeRequest('rest/internal/action/checkAddress',
                {
                    "countryCode": stato,
                    "province":provincia,
                    "town": localita,
                    "street": via,
                    "streetNumber": civico,
                    //"street": civico ? via + " " + civico : via,
                    "zipCode": ""
                },
                (data: Array<any>) => resolve(data),
                (error) => reject({ type: "SERVERE", content: error.statusText }),
                null,
                false,
                null,
                3000,
                false,
                false
            )
        })
    }

    GetItalianCitiesofProvinceJAKALA(country, province, searchText): Promise<any> {
        // return Promise.resolve(["TORINO","Grugliasco","MILANO","ASTI"]);
        if (this.citiesServiceSubscription)
            this.citiesServiceSubscription.unsubscribe();
        // set key to use it in case it was alresdy  invoked 
        var key = country + "-" + province + "-" + searchText;
        // if prov's cities are already already fetched 
        if (this.italianCitiesOfProvince.has(key)) {
            return Promise.resolve(this.italianCitiesOfProvince.get(key));
        }
        // else if prov's cities are not fetched 
        return new Promise((resolve, reject) => {
            this.citiesServiceSubscription = this._requestService.makeRequest('rest/internal/action/retrieveLocations',
                {
                    "countryCode": country,
                    "province": province,
                    "searchText": searchText
                },
                (data: Array<any>) => {
                    this.italianCitiesOfProvince.set(key, data);
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText })
                },
                null,
                false,
                null,
                4000,
                false,
                false)
        })
    }
}




// WEBPACK FOOTER //
// ./src/app/theme/services/address.service.ts